export default "__VITE_ASSET__DtG8Fprb__"